interface IMilestone {}

interface ICargoProcessOnlyMilestones<T> {
  milestones: Record<string, T | undefined>
}
export function getAllMilestones<T extends IMilestone>(
  carriagePlans: (ICargoProcessOnlyMilestones<T> | null)[]
): Record<string, T | undefined> {
  return carriagePlans.reduce(
    (allEvents, carriagePlan) => {
      return {
        ...allEvents,
        ...(carriagePlan && carriagePlan.milestones),
      }
    },
    {} as Record<string, T | undefined>
  )
}
